module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Medium-a5b9eede7f8c1e66549d72ce8606a87a.woff2";